import io from "socket.io-client";
import { actionCreators as devicesActionCreators } from "../actions/devicesActions";
import { actionCreators as uiActionCreators } from "../actions/uiActions";

import { handleTemplateVal } from "./palamoaTemplates"; 

const TEMPLATE_KEY_NAME = "template";

var socket;
export function socketTransciever(url, store) {
  let { dispatch } = store;
  let {
    receiveRawJSONForDevice,
    receiveSensorValuesForDevice,
    receiveResultPropertiesForDevice,
    receiveSensorResultPropertiesForDevice
  } = devicesActionCreators;

  console.log("sockettransciever init");

  socket = io(url);

  socket.on("connect", function() {
    console.log("socket connected");
    //toast.success("Connected to server!")
  });

  // "news" is the event name for raw JSON strings ans sensorvalues, which get send by the server before it gets the config from the client.
  // The raw JSON strings will be stored per device in a 3 elem array
  socket.on("news", function(evt) {
    if (!evt.event || !evt.event.combined || !evt.event.id) {
      return;
    }
    // combined = raw JSON;
    let { id, combined = {}, sensor_values = [], result_properties = {} } = evt.event;
    // RAW JSONS
    dispatch(receiveRawJSONForDevice(id, combined));
    // SENSOR VALUES
    if (sensor_values.length > 0) {
      dispatch(receiveSensorValuesForDevice(id, sensor_values));
      // SENSOR RESULT PROPERTIES
      dispatch(receiveSensorResultPropertiesForDevice(id, sensor_values));
      console.log("socket sensor result props", sensor_values);
    }

    // DEVICE RESULT PROPERTIES
    if(Object.keys(result_properties).length > 0) {
      console.log("socket result props:", result_properties);
      dispatch(receiveResultPropertiesForDevice(id, result_properties));
    }
    

    // TEMPLATE INFO
    // Parse the raw JSON for a template key. For now only look for querx templates.
    // When a querx template code is recognized, offer to automatically config the according device.
    
    if (evt.event.combined.hasOwnProperty(TEMPLATE_KEY_NAME)) {
      handleTemplateVal(id, evt.event.combined[TEMPLATE_KEY_NAME], store, devicesActionCreators, uiActionCreators);
    }

    console.log("socket event received", evt.event);
  });

  socket.on("disconnect", function() {
    //toast.error("Disconnected from server!")
    console.log("socket disconnected");
  });
}



export function disconnectSocket() {
  try {
    socket.disconnect();
  } catch (error) {
    console.error(error);
  }
}
